// src/components/propertyPanel/ComponentProperties/ProductDetailProperties.js
import React from 'react';
import { useSelector } from 'react-redux';
import { selectSelectedComponent } from '../../../redux/editorSlice';
import { usePropertyPanel } from '../PropertyPanelContext';
import { PaddingControl } from '../CommonProperties';

const ProductDetailProperties = () => {
  // 선택된 컴포넌트 가져오기
  const selectedComponent = useSelector(selectSelectedComponent);
  
  // 컨텍스트에서 필요한 함수 가져오기
  const { handleComponentPropsChange } = usePropertyPanel();
  
  // 컴포넌트 속성 변경 핸들러
  const handlePropertyChange = (property, value) => {
    if (!selectedComponent) return;
    handleComponentPropsChange(property, value);
  };

  return (
    <>
      {/* <PaddingControl /> */}
      
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
            <path d="M7 7H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M7 12H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M7 17H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
          탭 표시 설정
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>설명(Description) 탭</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-description-tab"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showDescriptionTab !== false}
              onChange={(e) => handlePropertyChange('showDescriptionTab', e.target.checked)}
            />
            <label htmlFor="toggle-description-tab" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>리뷰(Reviews) 탭</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-reviews-tab"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showReviewsTab !== false}
              onChange={(e) => handlePropertyChange('showReviewsTab', e.target.checked)}
            />
            <label htmlFor="toggle-reviews-tab" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        {/* <div className="property-row">
          <label style={{ minWidth: '30%' }}>상세 스펙(Specification) 탭</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-specification-tab"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showSpecificationTab !== false}
              onChange={(e) => handlePropertyChange('showSpecificationTab', e.target.checked)}
            />
            <label htmlFor="toggle-specification-tab" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div> */}
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>재고 정보 표시</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-stock-display"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showStock === true}
              onChange={(e) => handlePropertyChange('showStock', e.target.checked)}
            />
            <label htmlFor="toggle-stock-display" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductDetailProperties;